<template>
  <div class="container container-message text-center">
    <!-- Title -->
    <h1 class="alert-heading">{{ $t('forbiddenHeader')}}</h1>
    <!-- Message -->
    <p>
      {{ $t('forbiddenBody1')}}
    </p>
    <p>
      {{ $t('forbiddenBody2')}}
    </p>
    <!-- Return Button -->
    <router-link to="/" class="btn custom-button">{{ $t('notFoundReturn')}}</router-link>
  </div>
</template>

<script>
export default {
  name: 'Forbidden',
};
</script>

<style scoped>
</style>
